module.exports = __webpack_public_path__ + "static/img/kwsb-details.ce3e365.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/kwsb-details.png
// module id = xGal
// module chunks = 0